import { listLazyRoutes } from '@angular/compiler/src/aot/lazy_routes';
import { Component, OnInit } from '@angular/core';
import { GetMessageResponse } from '../shared/get-message-response';
import { PostMessageRequest } from '../shared/post-message-request';
import { RestApiService } from '../shared/rest-api.service';


@Component({
  selector: 'app-chat-inbox',
  templateUrl: './chat-inbox.component.html',
  styleUrls: ['./chat-inbox.component.css']
})
export class ChatInboxComponent implements OnInit {

  message: string;
  nickname = '';
  messages = [];

  constructor(public restApi: RestApiService ) { }

  ngOnInit() {
    this.updateChat();
  }

  async updateChat() {
    document.getElementById('message-list').innerHTML = '';
    this.restApi.getMessages().subscribe((response: GetMessageResponse) => {
      console.log(response);
      // tslint:disable-next-line:triple-equals
      if (response && response.success == true) {
        this.messages = response.data.messages;
        if (this.messages.length > 0 ) {
          // tslint:disable-next-line:only-arrow-functions
          this.messages.forEach(function(message) {
            const element = document.createElement('li');
            element.innerHTML = message;
            /**element.style.background = 'white';
            element.style.padding =  '15px 30px';
            element.style.margin = '10px';
            element.style.textAlign = 'right'; */
            if (message.toString().includes('*') || message.toString().includes('@') || message.toString().includes('#')) {
              element.className = 'list-group-item list-group-item-danger';
            } else {
              element.className = 'list-group-item list-group-item-light';
            }
            document.getElementById('message-list').appendChild(element);
          })
        }
      }
    })

  }

  sendMessage() {
    if (this.message && this.message.trim().length > 0) {
      // tslint:disable-next-line:triple-equals
      if (this.nickname.trim().length == 0){
        this.nickname = 'Anonimo';
      }

      this.restApi.sendMessage(new PostMessageRequest(this.nickname, this.message)).subscribe((data: {}) => {
        this.message = '';
        console.log(data);
        this.updateChat();
      });

    }
  }

}
